<form id="register-form" [formGroup]="formGroup" (ngSubmit)="saveItem($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ formerItem.orgCode }} - {{ formerItem.orgDescription }}</span>
    <button type="button" class="icon-button icon-close" (click)="goToResponsible(formerItem)"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <mat-form-field class="label-input required">
                <label>
                  {{ (item.responsibleType === "sag" ? "responsible.item.sagUnit" : "responsible.item.corporateCountry") | translate }}
                </label>
                <input matInput formControlName="title" />
              </mat-form-field>
            </div>
            <div class="flex-1 card-cell">
              <mat-form-field class="label-input required">
                <label>
                  {{ (item.responsibleType === "sag" ? "responsible.item.orgCode" : "responsible.item.code") | translate }}
                </label>
                <input matInput formControlName="code" />
              </mat-form-field>
            </div>
          </div>
          @if (item.responsibleType === ResponsibleType.rc) {
            <div class="flex-row">
              <div class="flex-1 card-cell">
                <reporting-tool-chip
                  formControlName="assignedCountries"
                  placeholder="responsible.item.assignedCountries"
                  [removable]="true"
                  (ngModelChange)="changeAssignedCountries($event)" />
              </div>
            </div>
          }
        </div>
      </div>
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "responsible.item.executiveMember" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker
                placeholder="responsible.item.signFunction"
                formControlName="mainResponsible"
                [required]="true"
                [exclude]="excludedUsers"
                [multiple]="true" />
            </div>
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker
                placeholder="responsible.item.otherFunction"
                formControlName="otherResponsible"
                [required]="false"
                [exclude]="excludedUsers"
                [multiple]="true" />
            </div>
          </div>
        </div>
      </div>
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "responsible.item.specialistFunction" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker
                placeholder="responsible.item.signFunction"
                formControlName="mainSpecialists"
                [required]="true"
                [exclude]="excludedUsers"
                [multiple]="true" />
            </div>
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker
                placeholder="responsible.item.otherFunction"
                formControlName="otherSpecialists"
                [required]="false"
                [exclude]="excludedUsers"
                [multiple]="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
